import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ThemeModeComponent, ThemeModeType } from '@donstudio/ds/layout';
import { DOCUMENT } from '@angular/common';
import { IS_BROWSER_PLATFORM, LOCAL_STORAGE, LOCATION } from '@donstudio/ds/_tokens';

export { ThemeModeType } from '@donstudio/ds/layout';

const themeModeLSKey = 'ds_theme_mode_value';
const themeMenuModeLSKey = 'ds_theme_mode_menu';

@Injectable({
  providedIn: 'root',
})
export class ThemeModeService {
  systemMode: ThemeModeType = 'light';

  public mode: BehaviorSubject<ThemeModeType> =
    new BehaviorSubject<ThemeModeType>(
      this.getThemeModeFromLocalStorage(themeModeLSKey)
    );
  public menuMode: BehaviorSubject<ThemeModeType> =
    new BehaviorSubject<ThemeModeType>(
      this.getThemeModeFromLocalStorage(themeMenuModeLSKey)
    );

  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(LOCATION) private location: Location,
    @Inject(LOCAL_STORAGE) private localStorage: Storage,
    @Inject(IS_BROWSER_PLATFORM) private isBrowser: boolean,
  ) {
    if (isBrowser) {
      this.systemMode = ThemeModeComponent.getSystemMode();
      ThemeModeComponent.init();
    }
  }

  public updateMode(_mode: ThemeModeType) {
    const updatedMode = _mode === 'system' ? this.systemMode : _mode;
    this.mode.next(updatedMode);

    if (this.localStorage) {
      this.localStorage.setItem(themeModeLSKey, updatedMode);
    }

    this.document.documentElement.setAttribute('data-bs-theme', updatedMode);
  }

  public updateMenuMode(_menuMode: ThemeModeType) {
    this.menuMode.next(_menuMode);
    if (this.localStorage) {
      this.localStorage.setItem(themeMenuModeLSKey, _menuMode);
    }
  }

  public init() {
    this.updateMode(this.mode.value);
    this.updateMenuMode(this.menuMode.value);
  }

  public switchMode(_mode: ThemeModeType) {
    // if (this.localStorage) {
    //   const updatedMode = _mode === 'system' ? this.systemMode : _mode;
    //   this.localStorage.setItem(themeModeLSKey, updatedMode);
    //   this.localStorage.setItem(themeMenuModeLSKey, _mode);
    // }
    // this.location.reload()
    this.updateMode(_mode);
    this.updateMenuMode(_mode);
  }

  public getThemeModeFromLocalStorage(lsKey: string): ThemeModeType {
    if (!this.localStorage) {
      return 'light';
    }

    const data = this.localStorage.getItem(lsKey);
    if (!data) {
      return 'light';
    }

    if (data === 'light') {
      return 'light';
    }

    if (data === 'dark') {
      return 'dark';
    }

    return 'system';
  }
}
